import moment from 'moment';
import React, { useEffect } from 'react';
import { IMarker } from '../../sheard/interfaces/Marker';

const iconSocial = (channelTypeID: string) => {
  switch (channelTypeID) {
    case 'facebook':
      return 'la la-facebook';
    case 'instagram':
      return 'la la-instagram';
    case 'twitter':
      return 'la la-twitter';
    case 'youtube':
      return 'la la-youtube';
    default:
      return '';
  }
};

const popupContent = (marker: IMarker) => `
    <div class='item'>
      <a class='feed' href='${marker.link}' target='_blank'>
        <div class='feed-tags'>
          <p><i class='${iconSocial(marker.channel_type_id)}'></i></p>
        </div>
        <div class='image'><img src='${marker.background_image}' alt='' /></div>
        <div class='detail'>
          <header>
            <span class='avatar'><img src='${marker.user_avatar_url}' alt=''/></span>
            <p class='name' style='max-width: 140px;'>${marker.username}</p>
            <p class='date-time'>${moment(marker.created_time * 1000).format('DD/MM/YYYY [at] hh:mm a')}</p>
          </header>
          <div class='message'>
            <p>${marker.message}</p>
          </div>
          <ul class='summary'>
            <li>
              <p><i class='fas fa-thumbs-up'></i>${marker.likes_count}</p>
            </li>
            <li>
              <p><i class='fas fa-comment'></i>${marker.comment_count}</p>
            </li>
            <li>
              <p><i class='fas fa-share'></i>${marker.share_count}</p>
            </li>
          </ul>
        </div>
      </a>
    </div>
  `;

const LeafletMap = (props: { markers: IMarker[] }) => {
  const {markers} = props;
  useEffect(() => {
    const _window: any = window;
    if (!_window.L) {
      return;
    }
    const L = _window.L;
    const map = L.map('map').setView([13.736717, 100.523186], 5.5);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png', {
      maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    const markerLayer = L.markerClusterGroup();
    (markers || []).forEach((m: IMarker) => {
      const marker = L.marker([m.location.lat, m.location.lon]);
      markerLayer.addLayer(marker);
      marker.on('mouseover', () => {
        marker.bindPopup(() => popupContent(m), { autoClose: true }).openPopup();
      });
    });
    map.addLayer(markerLayer);

    return () => {
      map.remove();
    };

  }, [markers]);

  return (<div id='map' style={{ height: '720px', width: '100%' }}></div>);
};

export default LeafletMap;
